var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep11To8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 108,
    viewBox: "0 0 464 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70711 0.292893C8.31658 -0.097631 7.68342 -0.0976312 7.2929 0.292893L0.928933 6.65685C0.538409 7.04738 0.538409 7.68054 0.928933 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68055 15.4616 7.04738 15.0711 6.65686L8.70711 0.292893ZM443 54.8349L28 54.8348L28 56.8348L443 56.8349L443 54.8349ZM8.99999 35.8348L9 1L7 1L6.99999 35.8348L8.99999 35.8348ZM462 75.8348L462 108L464 108L464 75.8348L462 75.8348ZM28 54.8348C17.5066 54.8348 8.99999 46.3282 8.99999 35.8348L6.99999 35.8348C6.99999 47.4328 16.402 56.8348 28 56.8348L28 54.8348ZM443 56.8349C453.493 56.8349 462 65.3414 462 75.8348L464 75.8348C464 64.2369 454.598 54.8349 443 54.8349L443 56.8349Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep11To8);
export default __webpack_public_path__ + "static/media/step_11_to_8.4050bdb0064aa039a8b6f28b150dd730.svg";
export { ForwardRef as ReactComponent };